import _ from "underscore";
import Loading from "shared/loading";
import { toastResponseError } from "../helpers/errors";
import Modal from "shared/modal";

export default class DeactivateIntegrationModal extends Modal {
  constructor(options) {
    _.defaults(options, { modalBody: 'Placeholder' });

    super(options);

    this.app = options.app;
    if (!this.app) {
      throw new Error("App needs to be passed in to be able to operate");
    }
    this.modalBody = options.modalBody;
    this.successFn = options.successFn;
    this.successUrl = options.successUrl || this.app.config.urlConfig.return_to_integrations;
  }

  title() {
    return 'Deactivate this Connect App?';
  }

  body() {
    return this.modalBody;
  }

  buttons() {
    return [
      {
        text: "Cancel",
        className: 'btn-secondary cancel-deactivate',
        close: true
      },
      {
        click: function() {
          var modalDialog = this.parent;
          modalDialog._onSubmit();
        },
        text: "Deactivate",
        className: "btn-danger submit-deactivate"
      }
    ];
  }

  _onSubmit() {
    var modalDialog = this;
    Loading.show(this.$('.modal-content'));

    var defaultSuccessFn = function(model, modalDialog, data, statusText) {
      Loading.hide();
      this.app.navigateTo(this.successUrl);
    }.bind(this);

    var errorFn = function(model, modalDialog, xhr, statusText, error) {
      Loading.hide();
      toastResponseError(xhr);
      modalDialog.close();
    };

    this.model.deactivateIntegration(modalDialog, this.successFn || defaultSuccessFn, errorFn);
  }
}
